export enum Icon {
    CHECK = 'check',
    CRYING_CAT_FACE = 'crying-cat-face',
    HEART_EYES_CAT = 'heart-eyes-cat',
    SMILEY_CAT = 'smiley-cat',
    WARNING = 'warning',
    TRUMPET = 'trumpet',
    TROPHY = 'trophy',
    SECOND_PLACE_MEDAL = 'second-place-medal',
    THIRD_PLACE_MEDAL = 'third-place-medal',
}
